module.exports = __webpack_public_path__ + "static/media/white-outline-star.75da301e.svg";